module.exports = __webpack_public_path__ + "media/images/patent/y_13-577f6a7261ff2c5cc7868fec32240f53.jpg";